import { useAuthContext } from '@isyc-react/auth/modules/context';
import clsx from 'clsx';
import React from 'react';
export const TextSmComponent = props => {
  var _user$person, _user$person2;
  const {
    subTitleOnClick,
    nameOnClick,
    subTitle,
    disableName,
    addComponent
  } = props;
  const {
    user
  } = useAuthContext();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    tabIndex: 12,
    className: clsx('col', {
      'd-flex align-items-center': !subTitle
    })
  }, !disableName && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: clsx('mb-0', {
      'cursor-pointer text-decoration-underline': nameOnClick
    }),
    onClick: nameOnClick
  }, user === null || user === void 0 || (_user$person = user.person) === null || _user$person === void 0 ? void 0 : _user$person.name, " ", user === null || user === void 0 || (_user$person2 = user.person) === null || _user$person2 === void 0 ? void 0 : _user$person2.surname), addComponent), subTitle && /*#__PURE__*/React.createElement("small", {
    className: clsx({
      'cursor-pointer': subTitleOnClick
    }),
    onClick: subTitleOnClick
  }, "(", subTitle, ")")));
};
export const TextLgComponent = props => {
  var _user$person3, _user$person4;
  const {
    subTitleOnClick,
    nameOnClick,
    subTitle,
    disableName,
    addComponent
  } = props;
  const {
    user
  } = useAuthContext();
  const capitalizeFirstLetter = word => {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !disableName && (user === null || user === void 0 || (_user$person3 = user.person) === null || _user$person3 === void 0 ? void 0 : _user$person3.name) && (user === null || user === void 0 || (_user$person4 = user.person) === null || _user$person4 === void 0 ? void 0 : _user$person4.surname) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: clsx('text-center font-size-16 text-black mt-4 mb-5 fw-semibold'),
    onClick: nameOnClick
  }, capitalizeFirstLetter(user.person.name), " ", capitalizeFirstLetter(user.person.surname)), addComponent), subTitle && /*#__PURE__*/React.createElement("small", {
    className: clsx('d-flex justify-content-center', {
      'cursor-pointer': subTitleOnClick
    }),
    onClick: subTitleOnClick
  }, "(", subTitle, ")"));
};